import { createFileRoute, Link, Outlet, redirect } from "@tanstack/react-router";

/** Hiding this in the SPA is convenience only; every /api/admin/* route checks on the server. */
export const Route = createFileRoute("/_app/admin")({
  beforeLoad: ({ context }) => {
    if (context.me.user.platformRole !== "admin") throw redirect({ to: "/" });
  },
  component: () => (
    <div className="mx-auto flex max-w-7xl flex-col gap-4 p-6">
      <div className="flex items-center gap-4 border-b border-border">
        <h1 className="mr-4 py-2 text-xl font-semibold tracking-tight">Platform admin</h1>
        {(
          [
            ["/admin", "Organizations"],
            ["/admin/users", "Users"],
            ["/admin/usage", "Usage & AI cost"],
          ] as const
        ).map(([to, label]) => (
          <Link
            key={to}
            to={to}
            activeOptions={{ exact: true }}
            className="-mb-px border-b-2 border-transparent py-2 text-sm text-muted-foreground"
            activeProps={{ className: "border-primary! text-foreground!" }}
          >
            {label}
          </Link>
        ))}
      </div>
      <Outlet />
    </div>
  ),
});
